















import { authHelper } from '@homeserve/vue-auth-plugin';
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import Logo from './Logo.vue';

@Component({ components: { Logo } })
export default class Navbar extends Vue {
  @State('userAuthenticated', { namespace: 'auth' })
  public isAuthenticated!: boolean;

  public async logout() {
    await authHelper.logout(this.$store);

    this.$router.push({ name: 'home' });
  }
}
